import React, { useEffect } from 'react'
import Icon from 'components/Icon'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'

const PostProduction = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled } = attribute
  const { selected, note } = state || { selected: true, note: '' }
  const { formatMessage } = useIntl()

  useEffect(() => {
    // This will only run the first time the component received valid props
    // making sure to set the defaults to selected
    if (attribute && !state) {
      onChange({ selected, note })
    }
  }, [attribute, state])

  const onClick = () => {
    if (options.includes(!selected)) {
      onChange({ ...state, selected: !selected })
    }
  }

  return (
    <fieldset className="space-y-2">
      <div className="flex justify-between items-center">
        <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
          { name }
        </p>

        <button disabled={disabled} type="button" className={`shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary ${disabled ? 'cursor-not-allowed' : ''}`} aria-pressed="false" onClick={onClick}>
          <span className="sr-only"><FormattedMessage{...messages.setting}/></span>
          <span aria-hidden="true" className="pointer-events-none absolute bg-white w-full h-full rounded-sm"></span>
          <span aria-hidden="true" className={`${selected ? 'bg-primary' : 'bg-gray-200'} pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200`}></span>
          <span aria-hidden="true" className={`${selected ? 'translate-x-5' : 'translate-x-0'} pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200`}></span>
        </button>
      </div>

      { selected &&
        <textarea
          type="text"
          placeholder={formatMessage(messages.note)}
          value={note}
          onChange={({ target: { value } }) => onChange({ ...state, note: value })}
          className={`w-full p-2 px-3 focus:border-primary transition duration-200 border border-gray-300`}
        />
      }
    </fieldset>
  )
}

export default PostProduction
